var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('div',{staticClass:"d-md-flex"},_vm._l((_vm.expectedLength),function(i){return _c('v-skeleton-loader',{key:i,attrs:{"type":"image","height":"100","width":_vm.itemWidth}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }